import type {ActiveFilters} from '../components/FilterBar';

export const ACTIVE_STATUSES = ['open', 'in_progress', 'waiting_on_customer'];

export function getDefaultFilters(role: 'agent' | 'lead' | 'admin', userId: string): ActiveFilters {
	if (role === 'agent' && userId) {
		return {
			status: [...ACTIVE_STATUSES],
			priority: [],
			sla_status: [],
			assignee_id: [userId],
			label_id: [],
			requester_id: [],
			created_after: '',
			created_before: '',
			updated_after: '',
			updated_before: '',
		};
	}
	return {
		status: [...ACTIVE_STATUSES],
		priority: [],
		sla_status: [],
		assignee_id: [],
		label_id: [],
		requester_id: [],
		created_after: '',
		created_before: '',
		updated_after: '',
		updated_before: '',
	};
}
